import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCredits } from '../../contexts/CreditContext';
import { ThemeToggle } from '../ThemeToggle';

const Navigation: React.FC = () => {
  const { user, signOut } = useAuth();
  const { credits, fetchCredits } = useCredits();
  const location = useLocation();

  // Fetch credits when navigation mounts
  React.useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="navbar bg-base-100 shadow-lg">
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </div>
          <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
            <li><Link to="/dashboard" className={isActive('/dashboard') ? 'active' : ''}>Dashboard</Link></li>
            <li><Link to="/transactions" className={isActive('/transactions') ? 'active' : ''}>Transactions</Link></li>
            <li><Link to="/buy-credits" className={isActive('/buy-credits') ? 'active' : ''}>Buy Credits</Link></li>
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost text-xl">SuprHR</Link>
      </div>
      
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1">
          <li><Link to="/dashboard" className={isActive('/dashboard') ? 'active' : ''}>Dashboard</Link></li>
          <li><Link to="/transactions" className={isActive('/transactions') ? 'active' : ''}>Transactions</Link></li>
          <li><Link to="/buy-credits" className={isActive('/buy-credits') ? 'active' : ''}>Buy Credits</Link></li>
        </ul>
      </div>
      
      <div className="navbar-end">
        <div className="flex items-center gap-4">
          {/* Enhanced Credits Display */}
          <div className="hidden md:flex items-center gap-2 bg-base-200 px-3 py-2 rounded-lg">
            <div className="flex items-center gap-2">
              <div className="p-1 rounded-full bg-success/10">
                <svg 
                  className="w-4 h-4 text-success"
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM8.5 12.5L7 11l-1.5 1.5L7 14l1.5-1.5zM13 11l-1.5-1.5L10 11l1.5 1.5L13 11z"/>
                </svg>
              </div>
              <div className="text-sm">
                <div className="font-semibold text-base-content">{credits?.credit_balance || 0}</div>
                <div className="text-xs text-base-content/60">credits</div>
              </div>
            </div>
          </div>
          
          {/* Mobile credits badge */}
          <div className="md:hidden badge badge-primary">
            {credits?.credit_balance || 0} Credits
          </div>
          
          <ThemeToggle />
          
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
              <div className="w-10 rounded-full">
                <img alt="User" src={user?.user_metadata?.avatar_url || 'https://via.placeholder.com/40'} />
              </div>
            </div>
            <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
              <li>
                <div className="text-sm opacity-75">
                  {user?.user_metadata?.full_name || user?.email}
                </div>
              </li>
              <li><button onClick={signOut}>Logout</button></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation; 